import controller from './newSubCase.controller';
import template from './newSubCase.pug';

const SubCaseComponent = {
  template,
  controller,
};

export default SubCaseComponent;



// WEBPACK FOOTER //
// ./client/app/cases/newSubCase/newSubCase.component.js